import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button } from "react-bootstrap";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/reusable/ScrollToTop";
import Router from "./components/Router";
import { Helmet } from "react-helmet";
import { useEffect } from 'react';
function App() {

    return (
        <>
            <Helmet>
                <title>SMA Sunda Kelapa Menteng</title>
                <meta name="description" content="SMA Sunda Kelapa, yang berdiri sejak 8 Agustus 1963, merupakan salah satu lembaga pendidikan yang menjadi bagian integral dari Yayasan Pendidikan Sunda Kelapa. Yayasan ini didirikan dan dipimpin dengan penuh dedikasi oleh Ny. Hj. S. Moerdono, seorang tokoh pendidikan terkemuka pada zamannya. Proses pembentukan lembaga pendidikan ini juga mendapat kontribusi berharga dari Ibu Pia Alisyahbana dan Ibu Popy Awaludin, yang berperan sebagai pembina yang berdedikasi." />
            </Helmet>
            <BrowserRouter>
                <ScrollToTop />
                <Router />
            </BrowserRouter>
        </>

    );
}

export default App;
